import axios from 'axios';

import { authHeaders, getApiBase } from '../api/api';
import * as api from '../api/adapters/json_api';

// The Master Account months DAX has published (FIN-1263).
//
// Read-only on purpose: there is no create, no update and no delete, because
// the statement belongs to the ship — the only writing this screen does is
// `createDocument`, which raises one of the month's own documents, and `pull`,
// which stores DAX's own statement of a month without changing a figure of it.
const type = 'api_resources/dax_master_account_months';

export default {
  index: (pagination, sort, search, filter) => api.read({ type }, {
    query: {
      filter,
      page: { size: pagination.itemsPerPage, number: pagination.activePage },
    },
  }),

  show: (id) => api.read({ type, id }, {}),

  // What the filters can offer: the ships that have actually published a month
  // and the years they published in — never the whole fleet table, and never a
  // run of calendar years around today.
  filterOptions: () => api.read({ type, action: 'filter_options' }, {}),

  // The whole month as the page draws it: the four blocks and the state of
  // every document. Its own action rather than a field of the resource — the
  // list would otherwise serialize every wage line of every month to show ten
  // rows of period and vessel.
  view: (id) => api.read({ type, id, action: 'view' }, {}),

  // Raise one document of the month. Answers with the view again, because a
  // document changes the buttons, the badges and the variance at once.
  createDocument: (id, kind) => api.create({ type, id, action: 'create_document' }, {}, { kind }),

  // "Load from DAX" (22.09.2026): the month as DAX has it right now, submitted
  // or not. `pullOptions` asks DAX which ships it can answer for — the months
  // stored here cannot say, because the point is a month that has not arrived.
  pullOptions: () => api.read({ type, action: 'pull_options' }, {}),

  // The Settings dialog (02.10.2026): until which day the list opens on the
  // previous month, the templates of extra wage-order lines and each DAX
  // vessel's template and own lines — read and saved as one document.
  settings: () => api.read({ type, action: 'settings' }, {}),
  saveSettings: (payload) => api.update({ type, action: 'settings' }, {}, payload),
  pull: ({ imo, year, month }) => api.create({ type, action: 'pull' }, {}, { imo, year, month }),
  // The same pull for the month on screen; answers with its whole view.
  reload: (id) => api.create({ type, id, action: 'reload' }, {}, {}),

  // One piece of evidence — the receipt the Master photographed — as BYTES.
  //
  // Fetched rather than linked: this app authenticates with headers, and an
  // <img src> carries none, so a URL in the page would come back 401. The
  // caller turns the blob into an object URL and shows it in place.
  document: (id, externalId) => axios.get(
    `${getApiBase()}/api_resources/dax_master_account_months/${id}/document`,
    { params: { external_id: externalId }, headers: authHeaders(), responseType: 'blob' },
  ),

  // One of the month's Excel forms (02.11.2026) — ACC 08, the remittance list,
  // ACC 01 … — as BYTES too, and for the same reason: headers, not a link.
  workbook: (id, code) => axios.get(
    `${getApiBase()}/api_resources/dax_master_account_months/${id}/workbook`,
    { params: { code }, headers: authHeaders(), responseType: 'blob' },
  ),
};
